import type { ISitemapRemap } from '~/interfaces/dto/sitemap/response';
import { lockBodyScroll, unlockBodyScroll } from '~/utilities/ui-utilities';
import { globalKeys } from 'assets/data/global-keys';

export default function useWindowFunctions() {
  const { $pinia, $toggleChat, $toastService } = useNuxtApp();
  const { $promotionService, $storageService } = useServices();
  const siteStore = useSiteStore($pinia);
  const auth = useAuthStore($pinia);

  window.navigate = (path: string) => {
    navigateTo(path);
  };
  window.openModal = (modal: string) => {
    switch (modal.toLocaleLowerCase()) {
      case 'login':
        if (!auth.loggedIn) {
          siteStore.activateModal(modal);
        }
        break;

      case 'register':
        if (!auth.loggedIn) {
          siteStore.activateModal(modal);
        }
        break;

      case 'reset-password':
        if (auth.loggedIn) {
          auth.setAccountModalPage('password-management');
        } else {
          siteStore.activateModal('passwordResetStepOne');
        }
        break;

      case 'deposit':
        if (auth.loggedIn) {
          auth.setAccountModalPage('deposit');
        } else {
          siteStore.activateModal('login');
        }
        break;

      case 'withdrawal':
        if (auth.loggedIn) {
          auth.setAccountModalPage('withdrawal');
        } else {
          siteStore.activateModal('login');
        }
        break;

      default:
        break;
    }
  };
  window.displayLiveChat = () => $toggleChat();
  window.addEventListener('selectstart', function (e) {
    e.preventDefault();
  });

  window.promotions = {
    addTopNavigation: (sitemapEntry: Partial<ISitemapRemap>) => {
      siteStore.addToSiteMap({
        ...sitemapEntry,
        Navigation: { top: true, footer: false, left: false },
        MobileApp: {
          enabled: true,
          component: 'WebViewComponent',
          content: null,
        },
      });
    },
    triggerToast: (path: string) => {
      $toastService.generateToast(path);
    },
    revalidateSpinCounts: () => {
      $promotionService.getGenericWheelCount();
    },
    trackEvent: ({
      promotionName,
      event,
      eventParams,
    }: {
      promotionName: string;
      event: string;
      eventParams?: Record<string, unknown>;
    }) => {
      window.dataLayer.push({
        event: `promotion_${promotionName}_${event}`.toUpperCase(),
        ...eventParams,
      });
    },
  };

  window.lockBodyScroll = lockBodyScroll;
  window.unlockBodyScroll = unlockBodyScroll;

  window.getUserId = () => auth.currentUser?.id;
  window.getMobileNumber = () =>
    auth.currentUser?.primaryMobileNumber.mobileNumber;
  window.getMasterToken = () =>
    $storageService.getCookie<string | undefined>({
      key: globalKeys.marketingKeys.masterToken,
    });
  window.getBannerTag = () =>
    $storageService.getCookie<string | undefined>({
      key: globalKeys.marketingKeys.bannerTag,
    });
  window.getReferrerBannerTag = () =>
    $storageService.getCookie<string | undefined>({
      key: globalKeys.marketingKeys.referrerBannerTag,
    });

  window.insertScript = useScript;
}
